export default __webpack_public_path__ + "static/media/pdf-icon.ec2b4af3.svg";